module.exports = __webpack_public_path__ + "static/img/image040.dbfa63e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image040.png
// module id = zTDw
// module chunks = 1